export default "__VITE_ASSET__h2Lm_At0__"